import styled from '@emotion/styled';
import { Avatar as _Avatar } from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import {} from 'react';

interface Props {
  imageUrl?: string;
  name: string;
  small?: boolean;
  color?: 'inherit' | 'primary' | 'secondary' | 'action' | 'error' | 'disabled';
  className?: string;
}

const AvatarWithName = ({ imageUrl, name, small, color = 'primary', className }: Props) => {
  let avatar;
  if (!imageUrl) {
    avatar = small ? <SmallIcon color={color} /> : <Icon color={color} />;
  } else {
    avatar = small ? <SmallAvatar alt={name} src={imageUrl} /> : <Avatar alt={name} src={imageUrl} color={color} />;
  }

  return <Root className={className}>{avatar}</Root>;
};

export const Root = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

// const Avatar = styled(_Avatar)({
//   width: 28,
//   height: 28,
// });

const Avatar = styled(_Avatar)`
width:${(props) => {
  return props.color === 'primary' ? '28px;' : '40px;';
}}
height:${(props) => {
  return props.color === 'primary' ? '28px;' : '40px;';
}}
`;

const SmallAvatar = styled(_Avatar)({
  width: 20,
  height: 20,
});

// const Icon = styled(AccountCircle)({
//   width: 28,
//   height: 28,
//   color: 'white',
// });

const Icon = styled(AccountCircle)`
  width:${(props) => {
    return props.color === 'primary' ? '28px;' : '40px;';
  }}
  height:${(props) => {
    return props.color === 'primary' ? '28px;' : '40px;';
  }}
  color: ${(props) => {
    return props.color === 'primary' ? 'white;' : '#394151;';
  }}
`;

const SmallIcon = styled(AccountCircle)({
  width: 20,
  height: 20,
  color: 'white',
});

export default AvatarWithName;
